import { Box, FormControl, Grid, Radio, RadioGroup, Typography } from "@mui/material";
import React from "react";
import useResponsive from "../../../hooks/useResponsive";
import { selfAssessmentQuestions } from "../../../utils/selfAssessmentQuestions";
import ProfileDataCard from "./ProfileDataCard";

interface SelfAssessmentProps {
  selfAssessments: { name: string; value: number | null }[];
}

/**
 * This component displays the self-assessment of an applicant.
 * @param selfAssessments The self-assessments of an applicant.
 * @returns The self-assessment of an applicant.
 */
const SelfAssessment = ({ selfAssessments }: SelfAssessmentProps) => {
  const isMobile = useResponsive("down", "sm");

  const getSelfAssessmentValue = (questionKey: string) => {
    const questionNumber = questionKey.replace(/\D/g, ""); // Extract numeric part of questionKey
    const assessment = selfAssessments.find((assessment) => assessment.name.replace(/\D/g, "") === questionNumber);
    return assessment ? assessment.value : null;
  };

  return (
    <ProfileDataCard title="Selbsteinschätzung">
      <Grid container rowGap={isMobile ? 6 : 4}>
        {Object.keys(selfAssessmentQuestions).map((key) => {
          const value = getSelfAssessmentValue(key);
          return (
            <Grid container key={key} alignItems={"center"}>
              <Grid item xs={12} sm={4} display="flex" justifyContent="flex-start">
                <Typography
                  width={isMobile ? "50%" : "100%"}
                  textAlign={isMobile ? "left" : "right"}
                  fontSize={isMobile ? 14 : 16}
                >
                  {selfAssessmentQuestions[key].label1}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4} justifyContent={"space-evenly"}>
                <FormControl disabled sx={{ width: "100%" }}>
                  <RadioGroup row sx={{ justifyContent: "space-between", pl: 2, pr: 2 }} value={value}>
                    {[...Array(7)].map((_, i) => (
                      <Box key={i} flexGrow={1}>
                        <Radio
                          value={i + 1}
                          sx={{
                            p: 0,
                            "&.Mui-disabled": {
                              color: "rgba(0, 121, 140, 0.75)",
                            },
                          }}
                        />
                      </Box>
                    ))}
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4} display="flex" justifyContent="flex-end">
                <Typography
                  width={isMobile ? "50%" : "100%"}
                  textAlign={isMobile ? "right" : "left"}
                  fontSize={isMobile ? 14 : 16}
                >
                  {selfAssessmentQuestions[key].label2}
                </Typography>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </ProfileDataCard>
  );
};

export default SelfAssessment;
